import React from 'react';
import ContentLoader from 'react-content-loader';
import * as lib from '~/dependencies';

const Avatar = ({ size }) => (
  <div style={{ width: Number(size), height: Number(size) }}>
    <ContentLoader height={size - 34} width={size - 34} speed={1}>
      <circle cx="30" cy="30" r="30" />
    </ContentLoader>
  </div>
);

export default Avatar;

Avatar.defaultProps = {
  size: 100,
};

Avatar.propTypes = {
  size: lib.PropTypes.string,
};
